module.exports = __webpack_public_path__ + "media/KikiRick.c855717f.mp3";